import { Collapse } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SCollapse = styled(Collapse)``;
